import { render, staticRenderFns } from "./UploadArquivoSEI.vue?vue&type=template&id=1d28c0b8"
import script from "./UploadArquivoSEI.vue?vue&type=script&lang=js"
export * from "./UploadArquivoSEI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports